import { mapControl } from '@/constants';
export const iconSize = {
    active: {
        width: 40,
        height: 50,
    },
    related: {
        width: 32,
        height: 40,
    },
    default: {
        width: 32,
        height: 40,
    },
};
/**
 * 도착지 아이콘 경로 생성
 */
const getFilePath = (type, state) => `/svg/map-control/drop-${type}-${state}.svg`;
/**
 * 도착지 아이콘 생성
 */
export const createIcon = ({ naver, orderId, type, state, }) => {
    const filePath = getFilePath(type, state);
    const { width, height } = iconSize[state];
    return {
        anchor: new naver.maps.Point(width / 2, height),
        content: `<img    
      order-id="${orderId}"
      data-cy="mk-${orderId}"
      class="icon-drop" 
      title="[도착지] ${orderId}" 
      width="${width}" 
      height="${height}" 
      src="${filePath}"
    />`,
    };
};
const { MARKER_ICON_STATE, MARKER_ICON_TYPE } = mapControl;
/**
 * 도착지 아이콘
 */
export default ({ naver, orderId, isActive = false, relatedWeight = 0, isDelayedState, }) => {
    // 클릭 상태
    let state = MARKER_ICON_STATE.DEFAULT;
    if (isActive) {
        state = MARKER_ICON_STATE.ACTIVE;
    }
    else if (relatedWeight) {
        state = MARKER_ICON_STATE.RELATED;
    }
    // 지연 상태
    let type = MARKER_ICON_TYPE.NORMAL;
    if (isDelayedState) {
        type = MARKER_ICON_TYPE.DEPLAY;
    }
    return {
        isActive,
        relatedWeight,
        ...createIcon({
            naver,
            orderId,
            type,
            state,
        }),
    };
};
